import gql from 'graphql-tag'
export default gql`
mutation {
    resetSite(siteId: "34924c59-ca66-4770-92c9-395e068ae2eb" domain:"pastryplanet.inmyarea.in")
  }
  `